module.exports = __webpack_public_path__ + "static/media/DWK_03.6bf80340.jpg";